export default __webpack_public_path__ + "static/model_1-9ba900a2c14ef8d170acd2f1039e3ca8.webp";